import script from "./AccountsList.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountsList.vue?vue&type=script&setup=true&lang=js"

import "./AccountsList.vue?vue&type=style&index=0&id=c5437b26&lang=css"

const __exports__ = script;

export default __exports__